var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21C9.06667 21 7.41667 20.3167 6.05 18.95C4.68333 17.5833 4 15.9333 4 14V8C4 6.06667 4.68333 4.41667 6.05 3.05C7.41667 1.68333 9.06667 1 11 1C12.9333 1 14.5833 1.68333 15.95 3.05C17.3167 4.41667 18 6.06667 18 8V14C18 15.9333 17.3167 17.5833 15.95 18.95C14.5833 20.3167 12.9333 21 11 21ZM12 8H16C16 6.8 15.6208 5.74167 14.8625 4.825C14.1042 3.90833 13.15 3.33333 12 3.1V8ZM6 8H10V3.1C8.85 3.33333 7.89583 3.90833 7.1375 4.825C6.37917 5.74167 6 6.8 6 8ZM11 19C12.3833 19 13.5625 18.5125 14.5375 17.5375C15.5125 16.5625 16 15.3833 16 14V10H6V14C6 15.3833 6.4875 16.5625 7.4625 17.5375C8.4375 18.5125 9.61667 19 11 19Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseIcon);
export default __webpack_public_path__ + "static/media/MouseIcon.2e59fe961d4bdc5e8fbdd8116fb36ae1.svg";
export { ForwardRef as ReactComponent };